/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Incorrect_Url_Missing_CodeInputs */

const en_toast_incorrect_url_missing_code = /** @type {(inputs: Toast_Incorrect_Url_Missing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect URL! Missing code.`)
};

const nl_toast_incorrect_url_missing_code = /** @type {(inputs: Toast_Incorrect_Url_Missing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onjuiste URL! Code ontbreekt.`)
};

/**
* | output |
* | --- |
* | "Incorrect URL! Missing code." |
*
* @param {Toast_Incorrect_Url_Missing_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_incorrect_url_missing_code = /** @type {((inputs?: Toast_Incorrect_Url_Missing_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Incorrect_Url_Missing_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_incorrect_url_missing_code(inputs)
	return en_toast_incorrect_url_missing_code(inputs)
});